import React from 'react';
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
} from 'reactstrap';

export interface IPaginacaoProps {
  pagina: number;
  totalPaginas: number;
  total: number;
  limite: number;
  loading?: boolean;
  onPageChange: (novaPagina: number) => void;
  maxBotoes?: number;
  mostrarTotalizador?: boolean;
}

const Paginacao: React.FC<IPaginacaoProps> = ({
  pagina,
  totalPaginas,
  total,
  limite,
  loading = false,
  onPageChange,
  maxBotoes = 5,
  mostrarTotalizador = true,
}) => {
  const registroInicial = total === 0 ? 0 : (pagina - 1) * limite + 1;
  const registroFinal = Math.min(pagina * limite, total);

  const renderPaginationItems = () => {
    const items = [];
    let inicio = Math.max(1, pagina - 2);
    const fim = Math.min(totalPaginas, inicio + maxBotoes - 1);

    if (fim - inicio + 1 < maxBotoes) {
      inicio = Math.max(1, fim - maxBotoes + 1);
    }

    // Botão Primeira Página
    items.push(
      <PaginationItem key="first" disabled={pagina === 1 || loading}>
        <PaginationLink first onClick={() => onPageChange(1)} />
      </PaginationItem>,
    );

    // Botão Anterior
    items.push(
      <PaginationItem key="prev" disabled={pagina === 1 || loading}>
        <PaginationLink
          previous
          onClick={() => onPageChange(Math.max(1, pagina - 1))}
        />
      </PaginationItem>,
    );

    for (let i = inicio; i <= fim; i += 1) {
      items.push(
        <PaginationItem key={i} active={pagina === i} disabled={loading}>
          <PaginationLink onClick={() => onPageChange(i)}>{i}</PaginationLink>
        </PaginationItem>,
      );
    }

    // Botão Próximo
    items.push(
      <PaginationItem key="next" disabled={pagina === totalPaginas || loading}>
        <PaginationLink
          next
          onClick={() => onPageChange(Math.min(totalPaginas, pagina + 1))}
        />
      </PaginationItem>,
    );

    // Botão Última Página
    items.push(
      <PaginationItem key="last" disabled={pagina === totalPaginas || loading}>
        <PaginationLink last onClick={() => onPageChange(totalPaginas)} />
      </PaginationItem>,
    );

    return items;
  };

  return (
    <Row className="align-items-center w-100 m-0">
      {mostrarTotalizador && (
        <Col md="6" sm="12" className="mb-2 mb-md-0 p-0">
          <span className="text-muted" style={{ fontSize: '0.875rem' }}>
            Exibindo de <strong>{registroInicial}</strong> a{' '}
            <strong>{registroFinal}</strong> de{' '}
            <strong>{total.toLocaleString('pt-BR')}</strong> registros
          </span>
        </Col>
      )}
      <Col md={mostrarTotalizador ? '6' : '12'} sm="12" className="p-0">
        {totalPaginas > 1 && (
          <Pagination className="justify-content-md-end justify-content-center mb-0">
            {renderPaginationItems()}
          </Pagination>
        )}
      </Col>
    </Row>
  );
};

export default Paginacao;
